// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  STESSA_API_URL: 'https://api-stessa.dev.coditas.org/v1',
  // 'https://3jxbyk3f03.execute-api.ap-south-1.amazonaws.com/dev/v1',
  GSC_CLIENT_ID:
    '503670318142-5kvbo5e2bm7rgsuvdh0ejf5kbtasiq49.apps.googleusercontent.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
